import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import LabelAndInputMask from '../common/form/labelAndInputMask';

import {
	setModoTela, initForm, getLista
} from './laudoImportacaoActions';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import Td from '../common/table/td';
import FormatUtils from '../common/formatUtils/FormatUtils';
import TBody from '../common/table/tBody';
import DateFormat from '../common/dateFormat/DateFormat';

class LaudoImportacaoForm extends Component {

	state = {
		paginacaoIndice: 0,
	}

	componentWillMount() {
		this.props.getLista(this.props.formularioValues.competencia, this.props.formularioValues.id_hospital);
	}

	render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

		let lista = this.props.listaItens.map(item => ({
			...item
		}));

		let paginacao = [];

		if (lista.length) {
			for (let i = 0; i < lista.length; i += 500) {
				paginacao.push({
					inicio: i,
					fim: i + 499
				});
			}
		} else {
			paginacao.push({
				inicio: 0,
				fim: 499
			});
		}

		return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardHeader>
						<div class='row' style={{ display: 'flex', justifyContent: 'space-between' }}>
							<Grid cols='12 6 3 3'>
								<label style={{ paddingTop: 12 }}>Competência: {FormatUtils.formatarCompetenciaTela(this.props.formularioValues.competencia)}</label>
							</Grid>
							<Grid cols='12 6 6 6'>
								<label style={{ paddingTop: 12 }}>Hospital: {this.props.formularioValues.nome_hospital}</label>
							</Grid>
						</div>
					</ContentCardHeader>
					<ContentCardBody>
						<Row>

							<Field
								name='quantidade'
								component={LabelAndInputNumber}
								label='Quantidade *' placeholder='Informe'
								cols='12 12 4 4'
								casas={0}
								readOnly={readOnly} />

							<Field
								name='valor'
								component={LabelAndInputNumber}
								label='Valor *' placeholder='Informe'
								cols='12 12 4 4'
								casas={2}
								readOnly={readOnly} />
							
							<Field
								name='percentual_imposto'
								component={LabelAndInputNumber}
								label='Imposto (%) *' placeholder='Informe'
								cols='12 12 4 4'
								casas={2}
								readOnly={readOnly} />

						</Row>

					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
									<Button
										text='Salvar'
										submit
										type={'success'}
										icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>
				</Form>
			</ContentCard>
		);
	}


}

LaudoImportacaoForm = reduxForm({ form: 'laudoImportacaoForm', destroyOnUnmount: false })(LaudoImportacaoForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('laudoImportacaoForm')(state),
	listaItens: state.laudoImportacao.listaItens
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm, getLista
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(LaudoImportacaoForm);
